<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>IDENTIFICAÇÃO</b></h5>
        </th>
      </tr>

      <tr>
        <td colspan="3">
          NOME COMPLETO: <b>{{ usuario.nome_completo || '-' }}</b>
        </td>
        <td colspan="1">
          NASCIMENTO: <b>{{ usuario.data_nascimento || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          POSIÇÃO FAMILIAR: <b>{{ usuario.posicao_familiar || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          NOME SOCIAL: <b>{{ usuario.nome_social || '-' }}</b>
        </td>
        <td colspan="2">
          ORIGEM DO NOME SOCIAL:
          <b>{{ usuario.origem_nome_social || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="1">
          SEXO: <b>{{ usuario.sexo || '-' }}</b>
        </td>
        <td colspan="1">
          GÊNERO: <b>{{ usuario.genero || '-' }}</b>
        </td>
        <td colspan="1">
          COR OU RAÇA: <b>{{ usuario.cor_raca || '-' }}</b>
        </td>
        <td colspan="1">
          SITUAÇÃO CONJUGAL? <b>{{ usuario.estado_civil || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          FILIAÇÃO 1: <b>{{ usuario.mae || '-' }}</b>
        </td>
        <td colspan="2">
          FILIAÇÃO 2: <b>{{ usuario.pai || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          E-MAIL: <b>{{ usuario.email || '-' }}</b>
        </td>
        <td colspan="1">
          TELEFONE: <b>{{ usuario.telefone || '-' }}</b>
        </td>
        <td colspan="1">
          CELULAR/WHATSAPP: <b>{{ usuario.celular || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="1">
          PAÍS ONDE NASCEU: <b>{{ usuario.pais_nascimento || '-' }}</b>
        </td>
        <td colspan="1">
          ESTADO ONDE NASCEU: <b>{{ usuario.uf_nascimento || '-' }}</b>
        </td>
        <td colspan="2">
          CIDADE ONDE NASCEU:
          <b>{{ usuario.cidade_nascimento || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="1">
          IMIGRANTE: <b>{{ usuario.imigrante || '-' }}</b>
        </td>
        <td colspan="3">
          PAÍS ESTRANGEIRO ONDE NASCEU:
          <b>{{ usuario.pais_origem || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          CUMPRINDO PENA EM INSTITUIÇÃO PRISIONAL?
          <b>{{ usuario.cumprindo_pena || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="1">
          TEMPO DA PENA:
          <b>{{ usuario.tempo_pena || '-' }}</b>
        </td>
        <td colspan="1">
          PERÍODO:
          <b>{{ usuario.tempo_pena_periodo || '-' }}</b>
        </td>
        <td colspan="2">
          NOME DA INSTITUIÇÃO PRISIONAL:
          <b>{{ usuario.instituicao_prisional || '-' }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],
};
</script>

<style></style>